const configs = {
  env: process.env.NODE_ENV,
  clientId: process.env.REACT_APP_CLIENT_ID,
  obeliskApi: process.env.REACT_APP_API_URL,
  obeliskApiAuthKey: process.env.REACT_APP_API_KEY,
  pillarsApi: process.env.REACT_APP_PILLARS_URL,
  preEnrollRedirect: process.env.REACT_APP_PRE_ENROLL_REDIRECT_URL,
  sentryUri: process.env.REACT_APP_SENTRY_URI,
  botApi: process.env.REACT_APP_TELEGRAM_BOT_ENDPOINT,
  botKey: 'dd1f95df611b92f98a649cb3ad33d1a452422ac7377827c4178bcff2e69095ef',
  obeliskVersion: 1,
  pillarsVersion: 1,
  botVersion: 1,
  defaultHomePage: '/',
  enrollerLink: 'https://joinnoa.io/{{webAlias}}/enroll',
  maitryxLink: 'https://scan.maitryx.io?token=d268ijtmp9pcvd88tcu0&email={{email}}',
};

export default configs;
